const baseGroup = (id) => {
    return {
        id,
        groups: [],
        rules: [],
    };
};
const nest = (root, groupIds, rule, convert) => {
    let [id, ...rest] = groupIds;
    if (!root) {
        root = baseGroup(id);
    }
    if (rest.length === 0) {
        root.rules.push(convert(rule));
        return root;
    }
    if (root.id === id) {
        id = rest[0];
    }
    let group = root.groups.find(it => it.id === id);
    if (!group) {
        group = baseGroup(id);
        if (!root.groups || root.groups.length === 0) {
            root.groups = [group];
        }
    }
    nest(group, rest, rule, convert);
    return root;
};
const unflatten = (query, convert = it => it) => {
    const root = query.where.reduce((memo, it) => {
        const n = nest(memo, it.groupIds, it, convert);
        return n;
    }, undefined);
    return root;
};
module.exports = unflatten;
